import React from 'react';
import { Dialog } from 'dialog';
import { JobsiteFormSubmissionWorkerEdit } from 'containers/jobsiteFormSubmission/components/formSubmissionWorkers/types';
import {
  FormSubmissionWorkerEditSearch,
  getJobsiteWorkerForJobsite,
} from 'containers/jobsiteFormSubmission/components/formSubmissionWorkerEditSearch';
import { EditFormSubmissionWorkerModalProps } from './types';
import { FormSubmissionWorkerEditForm } from './components/formSubmissionWorkerEditForm/FormSubmissionWorkerEditForm';
import { toJfsWorkerEdit } from './utils';

export function EditFormSubmissionWorkerModal(
  props: EditFormSubmissionWorkerModalProps,
): React.ReactElement {
  const {
    isOpen,
    closeModal,
    onClosed,
    onConfirm,
    jobsiteId,
    jobsiteFormSubmissionId,
    jfsWorker,
    associationType,
    showInitialSearchResults,
  } = props;

  const outerJfsWorkerEdit = React.useMemo(
    () => toJfsWorkerEdit(jfsWorker),
    [jfsWorker],
  );
  const [innerJfsWorkerEdit, setInnerJfsWorkerEdit] =
    React.useState<JobsiteFormSubmissionWorkerEdit | null>();
  const jfsWorkerEdit = innerJfsWorkerEdit ?? outerJfsWorkerEdit;

  return (
    <Dialog
      id="editFormSubmissionWorker"
      open={isOpen}
      setOpen={closeModal}
      afterLeave={() => {
        onClosed?.();
        setInnerJfsWorkerEdit(null);
      }}
      title={`${
        jfsWorkerEdit?.editType === 'update' ? 'Update' : 'Add'
      } Worker`}
      actionsPanel={null}
    >
      {jfsWorkerEdit ? (
        <FormSubmissionWorkerEditForm
          jfsWorkerEdit={jfsWorkerEdit}
          onConfirm={onConfirm}
          onCancel={(): void => setInnerJfsWorkerEdit(null)}
        />
      ) : (
        <FormSubmissionWorkerEditSearch
          jobsiteFormSubmissionId={jobsiteFormSubmissionId}
          showInitialSearchResults={showInitialSearchResults}
          onSelected={(searchWorkerResult): void => {
            setInnerJfsWorkerEdit({
              id: searchWorkerResult.id,
              jobsiteWorker: getJobsiteWorkerForJobsite(
                searchWorkerResult,
                jobsiteId,
              ),
              extraData: { participantType: null },
              jobsitesInfo: searchWorkerResult.jobsitesInfo,
              editType: 'create',
              searchWorkerResult,
              associationType,
            });
          }}
        />
      )}
    </Dialog>
  );
}
